import * as React from "react"

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { withStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';

type ModalProps = {
  classes?: any,
  open: boolean,
  handleModalClose: () => void
}

class Notifier extends React.Component<WithTranslation & ModalProps, any> {
  state = {
    //open: true,
    width: window.innerWidth
  };

  componentDidMount() {

    this.updateWindowWidth();
    window.addEventListener('resize', this.updateWindowWidth);
  }


  updateWindowWidth = () => {
    this.setState({ ...this.state, width: window.innerWidth });
  }

  // handleModalClose = () => {
  //   let href = window.location.href
  //   // let herfTab = href.split("?")
  //   // let first = herfTab[0].split("/")
  //   // let link = ""
  //   // for (let i = 0; i < first.length -1; i++) {
  //   //   link += first[i] + "/"
  //   // }
  //   // if(herfTab.length > 1)
  //   //   link += "?" + herfTab[1]

  //   let link = href.replace("NotOK/", "Foto/");
  //   link = link.replace("OK/", "Foto/");
  //   window.open(link,"_self"); 
  // };

  //PM 2021-09-01
  //usuniecie disableBackdropClick
  render() {
    const classes = this.props.classes;

    return (
      <Dialog
        disableEscapeKeyDown
        maxWidth="sm"
        open={this.props.open}
      >
        <DialogTitle disableTypography>
          <Typography variant="h4" component="h2"
            className={classes.lowercase}
            color="error">
            <b><Trans>Failure</Trans></b>
          </Typography>
          <hr className={classes.hr} />
        </DialogTitle>
        <DialogContent >
          <Typography gutterBottom variant="h5" component="h2" className={classes.h5font} style={{}}>
            <Trans>Płatność internetowa</Trans>
          </Typography>
          <Typography gutterBottom variant="h5" component="h2" className={classes.h5font}>
            {'   * status:'} <b className={classes.error}>{"porażka"}</b>
          </Typography>
          <Typography gutterBottom variant="h5" component="h2" className={classes.h5font}>
            {'   * wynik:'} <b className={classes.error}>{"odrzucono zamówienie"}</b>
          </Typography>
          <Typography gutterBottom variant="h5" component="h2" className={classes.h5font}>
            {'   * sugestia:'} <b className={classes.error}><Trans>Agin</Trans> <Trans>Phone Contact</Trans></b>
          </Typography>
          <DialogContentText style={{ color: '#458B00' }} className={classes.dialogContentText}>
            {'    '}
          </DialogContentText>
          <Typography gutterBottom variant="h5" component="h2" className={classes.h5font}>
            {'   * powrót:'} <b className={classes.error}><Trans>Click OK to go to the main page</Trans></b>
          </Typography>

        </DialogContent>
        <DialogActions>
          <Button variant="outlined" size="small" onClick={this.props.handleModalClose}
            style={{ color: '#3a87ad', fontSize: "0.8125rem" }}>
            <b>ok</b>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme: Theme) => ({
  dialogContentText: {
    whiteSpace: 'pre' as 'pre'
  },
  hr: {
    marginTop: '10px'
  },
  lowercase: {
    textTransform: "lowercase" as "lowercase"
  },
  h5font: {
    fontSize: "1.0714285714285714rem",
    color: "#555",
    paddingLeft: "10px"
  },
  error: {
    color: theme.palette.error.main
  },
  primary: {
    color: theme.palette.primary.main
  },
});

export default withTranslation()(withStyles(styles)(Notifier));